import React, { useState } from "react";
import { getStatusColor } from "utils/helper";

import styles from "./Select.module.scss";

const Select = ({
  label,
  placeholder,
  value = "",
  name,
  onChange,
  options,
  disable = false,
  error,
  color = "#c4c4c4",
}) => {
  let [isOpen, setIsOpen] = useState(false);

  return (
    <div style={{ pointerEvents: disable ? "none" : "all" }}>
      <label className={styles.select_label}>{label}</label>
      <div
        className={styles.custom_select}
        onClick={() => setIsOpen(!isOpen)}
        tabIndex="0"
        style={{ borderColor: error ? "#f90500" : color }}
        onBlur={() => setIsOpen(false)}
      >
        <div className={styles.select_value}>
          {value !== "" ? (
            <span className={getStatusColor(value, false)}>{value}</span>
          ) : (
            <span className={styles.placeHolder}>{placeholder}</span>
          )}
          <i
            className="icon-drop-down"
            style={{
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            }}
          ></i>
        </div>
        <div
          className={styles.select_options}
          style={{ display: isOpen ? "block" : "none" }}
        >
          {options.map((list, index) => {
            return (
              <div
                key={index}
                className={styles.options}
                onClick={() => onChange({ name: name, value: list })}
              >
                <span>{list}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Select;
